import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { InvestmentsService } from '../../investments.service';
import { Summary } from '../models/summary';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../../shared/EventTypes';
import * as Chartist from 'chartist';

@Component({
	selector: 'app-investments-extract-details',
	templateUrl: './investments-extract-details.component.html',
	styleUrls: ['./investments-extract-details.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class InvestmentsExtractDetailsComponent implements OnInit {

	summary: Summary = new Summary();
	noApplication = true;

	constructor(private investmentsService: InvestmentsService) {
		// this.loadChart();
	}

	ngOnInit() {
		this.load();
	}

	load() {
		this.preload(true);

		this.investmentsService.getSummary('2017-01-01', new Date()).subscribe( data => {
			this.summary = data;

			if (this.summary.total > 0) {
				this.noApplication = false;

				let config = {};

				if (this.summary.totalPosPercent === 100) {
					config = {
						donut: true,
						donutWidth: 25,
						donutSolid: true,
						showLabel: true,
						chartPadding: 30,
						labelOffset: -130,
						labelDirection: 'implode',
					};
					
				} else {
					config = {
						donut: true,
						donutWidth: 25,
						donutSolid: true,
						showLabel: true,
						chartPadding: 30,
						labelOffset: 25,
						labelDirection: 'explode',
					};
				}

				const chart = new Chartist.Pie('.application-chart', {
					labels: ['PÓS-FIXADO ' +
					this.summary.totalPosPercentLabel, 'PRÉ-FIXADO ' + this.summary.totalPrePercentLabel ],
					series: [this.summary.totalPosPercent, this.summary.totalPrePercent]
				}, config); 

			} else {
				this.noApplication = true;
			}



			this.preload(false);
		}, error => {
			this.preload(false);
		});
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD, {element: '[data-component="investments-extract"] .content', show: active, delay: delay});
	}


}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/investments/investments-extract/investments-extract-details/investments-extract-details.component.ts